import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetReservations, actionSaveReservationState, registerOnChangeReservations,
        actionGetRestaurants, actionSelectRestaurant } from "../../actions/RestaurantActions"
import { LOGIN_ROUTE, TICKET_ADD_ROUTE, TICKET_EDIT_ROUTE } from "../../config/RoutesConstants"
import Roles from "../../config/RolesConstants"
import moment from "moment"
import { 
  Container, 
  IconButton,
  Badge,
  Button,
  Box, 
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle, 
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
  InputAdornment,
  Select,
  MenuItem,
  TextField
} from "@material-ui/core"
import DatePicker from "react-datepicker"
import ButtonCalendar from "../../components/ButtonCalendar/ButtonCalendar"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import ExpandIcon from '@material-ui/icons/ExpandMore';
import CollapseIcon from '@material-ui/icons/ExpandLess';
import CookIcon from '@material-ui/icons/LocalPizza';
import ListIcon from '@material-ui/icons/FormatListBulleted';
import PhoneVerifiedIcon from '@material-ui/icons/CheckCircle';
import PhoneUnverifiedIcon from '@material-ui/icons/Cancel';
// import DeliveryIcon from '@material-ui/icons/DirectionsBike';
// import TakeAwayIcon from '@material-ui/icons/Storefront';
import AcceptIcon from '@material-ui/icons/ThumbUp';
import RejectIcon  from '@material-ui/icons/ThumbDown'
import AcceptedIcon from '@material-ui/icons/Done';
import RejectedIcon from '@material-ui/icons/Close';
import Util, { ERROR, WARNING } from '../../common/Util'
import { typeInteger } from "../../common/Validations";
import TakeAwayIcon from "../../common/assets/smallTakeAwayIcon.png"
import DeliveryIcon from "../../common/assets/deliveryIcon.png"
import TableIcon from "../../common/assets/enmesaIcon.png"
import AlertIcon from "../../common/assets/noti_new.png"

const BOOKING_PENDING = 'pending'
const BOOKING_ACCEPTED = 'accepted'
const BOOKING_REJECTED = 'rejected'
class Reservations extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:25, count:0, bookings:[], filter:{bookState:{}, name:"", from:new Date(), to:moment().add(1,'week').toDate()}, cookView:false, expanded:{}, view:"list",
                bookingForReject:null, search:"", loadingData:true, changingState:false}    
    this.state[BOOKING_PENDING] = true
    this.state.filter.bookState[BOOKING_PENDING] = true
    this.state[BOOKING_ACCEPTED] = true
    this.state.filter.bookState[BOOKING_ACCEPTED] = true
    this.state[BOOKING_REJECTED] = true
    this.state.filter.bookState[BOOKING_REJECTED] = true
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.onSearch=this.onSearch.bind(this)
    this.onSearchKeyPress=this.onSearchKeyPress.bind(this)
    this.onSearchUser=this.onSearchUser.bind(this)
    this.onChangeRejectCommentSearch=this.onChangeRejectCommentSearch.bind(this)
    this.onConfirmReject=this.onConfirmReject.bind(this)
    this.onChangeDatesFrom=this.onChangeDatesFrom.bind(this)
    this.onChangeDatesTo=this.onChangeDatesTo.bind(this)
    this.onOpenCalendar=this.onOpenCalendar.bind(this)
    this.onSelectCalendar=this.onSelectCalendar.bind(this)
    this.unsubscribe=null
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    let notIsSuperAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN})<0)
    if(!this.props.restaurant.id&&notIsSuperAdmin&&this.props.profile.proRestoId){//Si no es super admin y no tiene restaurante seleccionado, busco el restaurante asociado al usuario
      this.props.actionGetRestaurants(
        ()=>{
          const restaurant = this.props.restaurantList&&this.props.restaurantList.filter((r)=>{return r.id = this.props.profile.proRestoId})
          this.props.actionSelectRestaurant(restaurant)
          this.unsubscribe = registerOnChangeReservations(restaurant,()=>{
            this.setState({loadingData:true})
            this.props.actionGetReservations(restaurant, this.state.filter, ()=>{this.onChangePage(null, this.state.page)}, this.getReservationsError)
          })
        }
        ,
        (e)=>{
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "Ocurrió un error al buscar el restaurant.")
        }
      )
    }
    
    if(this.props.restaurant){
      this.unsubscribe = registerOnChangeReservations(this.props.restaurant,()=>{
        this.setState({loadingData:true})
        this.props.actionGetReservations(this.props.restaurant, this.state.filter, ()=>{this.onChangePage(null, this.state.page)}, this.getReservationsError)
      })
    }
  }

  componentWillUnmount(){
    this.unsubscribe&&this.unsubscribe()
  }

  getReservationsError(e){
    console.log("ERROR AL LISTAR LAS RESERVAS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las reservas.")
  }

  onSearch(evt){
    this.setState({search:evt.target.value})
  }

  onChangeRejectCommentSearch(evt){
    this.setState({bookRejectComment:evt.target.value})
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let bookings = []
    bookings = this.props.bookingList||[]
    let count = bookings.length
    bookings=bookings&&bookings.slice(from, end)
    this.setState({page:newPage, count:count, bookings:bookings, loadingData:false, changingState:false})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let bookings = []
    bookings = this.props.bookingList||[]
    let count = bookings.length
    bookings=bookings&&bookings.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, bookings:bookings})
  }

  onSearchKeyPress(evt){
    const k = evt.which || evt.keyCode
    if(k==13) {//ENTER
      this.onSearchUser()
    }
  }

  onSearchUser(){
    // if(this.isValidSearch()){
      let filter = this.state.filter
      filter.name = this.state.search
      this.setState({filter:filter, loadingData:true})
      this.props.actionGetReservations(this.props.restaurant, filter, ()=>{this.onChangePage(null,this.state.page)}, this.getReservationsError)
      
    // }
  }


  onChangeStateCheck(check){
    let newState = {...this.state, loadingData:true}
    newState[check] = !newState[check]
    let filter = {...this.state.filter}
    filter.bookState[check]=newState[check]

    if(!newState[BOOKING_PENDING]&&!newState[BOOKING_ACCEPTED]&&!newState[BOOKING_REJECTED]){
      if(check==BOOKING_PENDING){
        filter.bookState[BOOKING_ACCEPTED]=true
        newState[BOOKING_ACCEPTED]=true
      }else{
        filter.bookState[BOOKING_PENDING]=true
        newState[BOOKING_PENDING]=true
      }
    }
    newState.filter = filter

    this.setState(newState)
    this.props.actionGetReservations(this.props.restaurant, newState.filter, ()=>{this.onChangePage(null,this.state.page)}, this.getReservationsError)

  }

  onAccept(item){
    this.setState({changingState:item.id})
    this.props.actionSaveReservationState({...item, bookState:BOOKING_ACCEPTED}, null, 
      (e)=>{
        console.log("ERROR onAccept", e)
        Util.showNoty(ERROR, "Tuvimos problemas para actualizar la reserva de " + item.bookName)
      }  
    )
  }
  
  onReject(item){
    this.setState({bookingForReject:item})
  }

  onConfirmReject(){
    if(!this.state.bookRejectComment){
      Util.showNoty(ERROR, "Debe indicar un motivo de rechazo")
    }else{
      let item = this.state.bookingForReject
      this.setState({changingState:item.id, bookingForReject:null})
      this.props.actionSaveReservationState({...item, bookRejectComment:this.state.bookRejectComment, bookState:BOOKING_REJECTED}, ()=>{
        this.setState({bookRejectComment:""})
      }, 
        (e)=>{
          this.setState({bookRejectComment:""})
          console.log("ERROR onConfirmReject", e)
          Util.showNoty(ERROR, "Tuvimos problemas para actualizar la reserva de " + item.bookName)
        }  
      )
    }
  }
  
  onChangeDatesFrom(d){
    let filter = {...this.state.filter}
    filter.from = d
    this.setState({filter:filter})
  }

  onChangeDatesTo(d){
    let filter = {...this.state.filter}
    filter.from = d
    this.setState({filter:filter})
  }

  onSelectCalendar(d){
    let ds = moment(d)
    const {from, to} = this.state.filter
    let filter = {...this.state.filter}
    let open = this.state.open
    if(from&&!to&&ds.isSameOrAfter(from,'d')){//Si está seleccionado el from y no el end y el valor es mayor al from, coloco el end
      filter.to=d
      open=false
      this.props.actionGetReservations(this.props.restaurant, filter, ()=>{this.onChangePage(null,this.state.page)}, this.getReservationsError)
    }else{  //cualquier otro caso selecciono el from
      filter.from=d
      filter.to=null
    }
    this.setState({filter:filter, open:open})
  }

  onOpenCalendar(){
    this.setState({open:true})
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Fecha a reservar", "Nombre", "DNI", "E-mail", "Nro. de personas", "Teléfono", "Fecha de solicitud", "Motivo de rechazo","Estado"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let bookings = this.state.bookings
    if(!bookings||bookings.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return bookings.map((item, index)=>{
      let stateLabel = ""
      let colorState = ""
      switch(item.bookState){
        case BOOKING_PENDING: stateLabel="Pendiente"; colorState="#1EC9A2"; break;
        case BOOKING_ACCEPTED: stateLabel="Aceptado"; colorState="green"; break;
        case BOOKING_REJECTED: stateLabel="Rechazado" ; colorState="red"; break;
        default: console.log("ESTADO DE RESERVA DESCONOCIDO", item.bookState); break;
      }
      const bookDate = Util.timestampToMoment(item.bookDate)
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell style={{position:"relative"}}>
          {item.bookState==BOOKING_PENDING&&<img src={AlertIcon} style={{width:30, position:"absolute", left:-30, top:10}}/>} 
            <Typography>
              {bookDate.format&&bookDate.format("HH:mm DD/MM") || bookDate}
            </Typography>
          </TableCell>
          <TableCell>{item.bookName}</TableCell>
          <TableCell>{Util.formatNumber(item.bookDocNumber)}</TableCell>
          <TableCell>{item.bookEmail}</TableCell>
          <TableCell>{item.bookPeopleNumber}</TableCell>
          <TableCell>{item.bookPhoneNumber}</TableCell>
          <TableCell>{Util.timestampToMoment(item.bookTime).format("HH:mm DD/MM")}</TableCell>
          <TableCell>{item.bookRejectComment}</TableCell>
          <TableCell>
              <Typography style={{color:colorState}}>{stateLabel}</Typography>
          </TableCell>
          <TableCell style={{...theme.table.actionsColumn, minWith:200}}>
            {this.state.changingState==item.id?
              <CircularProgress color="primary" size={20}/>
            :
            item.bookState == BOOKING_PENDING?
              [<Tooltip title="Aceptar reserva">
                <IconButton onClick={this.onAccept.bind(this, item)}>
                  <AcceptIcon htmlColor="green"/>
                </IconButton>
              </Tooltip>,
              <Tooltip title="Rechazar reserva">
              <IconButton onClick={this.onReject.bind(this, item)}>
                <RejectIcon htmlColor="red"/>
              </IconButton>
            </Tooltip>]
            : null
            // <Tooltip title={stateLabel}>
            //   {item.bookState==BOOKING_ACCEPTED?<AcceptedIcon htmlColor="#FF6E33"/>:<RejectedIcon htmlColor="red"/>}
            // </Tooltip>
            }
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, bookingList, restaurant } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">{restaurant&&restaurant.evtName}</Typography>
            {/* <Typography variant="subtitle1">Crea tickets para el restaurant seleccionado</Typography> */}
          </Box>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de reservas</Typography>
            <Toolbar style={theme.table.toolbar}>
              <Box style= {{flex:1}}>
                <Box style= {{display:"flex",  justifyContent:"space-between"}}>
                  <Input  placeholder="Nombre | DNI | E-mail" 
                          onChange={this.onSearch}
                          onKeyPress={this.onSearchKeyPress}
                          value={this.state.search}
                          style={{minWidth:220, marginRight:12}}
                          endAdornment={ 
                            <InputAdornment position="end">
                              <IconButton onClick={this.onSearchUser}>
                                <SearchIcon/>
                              </IconButton>
                            </InputAdornment> 
                          }
                  />
                  <Box>
                    <Typography className="MuiFormLabel-root MuiInputLabel-shrink">Fecha de reserva</Typography>
                    <DatePicker 
                          onSelect={this.onSelectCalendar} 
                          selected={this.state.filter.from}
                          selectStart
                          selectEnd
                          startDate={this.state.filter.from}
                          endDate={this.state.filter.to}
                          shouldCloseOnSelect={false}
                          locale="es"
                          customInput={<ButtonCalendar from={this.state.filter.from} to={this.state.filter.to} period={"custom"} onPress={this.onOpenCalendar} />}
                          open={this.state.open}
                          popperPlacement="top-end"
                          ></DatePicker>
                  </Box>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[BOOKING_PENDING]}
                          onChange={()=>this.onChangeStateCheck(BOOKING_PENDING)}
                          color="primary"
                          size="small"
                        />
                      }
                      label="Pendientes"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[BOOKING_ACCEPTED]}
                          onChange={()=>this.onChangeStateCheck(BOOKING_ACCEPTED)}
                          color="primary"
                        />
                      }
                      label="Aceptadas"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[BOOKING_REJECTED]}
                          onChange={()=>this.onChangeStateCheck(BOOKING_REJECTED)}
                          color="primary"
                        />
                      }
                      label="Rechazadas"
                    />
                    {this.state.loadingData&&<CircularProgress size={20} color="primary"/>}
                  </Box>
                </Box>
              </Box>
            </Toolbar>
            <Table stickyHeader>
              <TableHead > 
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableBody()}
              </TableBody>
            </Table> 
            <TableFooter>
              <TableRow>
                <TableCell align="right" style={{width:"70%"}}>
                 {this.state.loadingData&&<CircularProgress size={20} color="primary"/>}
                </TableCell>
                <TableCell align="right">
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    labelRowsPerPage="Reservas por página"
                    component="div"
                    count={this.state.count}
                    rowsPerPage={this.state.rowPerPage}
                    page={this.state.page}
                    onChangePage={this.onChangePage}
                    onChangeRowsPerPage={this.onChangeRowsPerPage}
                  />
                </TableCell>
              </TableRow>
            </TableFooter>
          </Paper>
          <Dialog open={this.state.bookingForReject}>
            <DialogTitle>Rechazar reserva</DialogTitle>
            <DialogContent>
              {/* <DialogContentText>Motivo de rechazo</DialogContentText> */}
              <TextField 
                      onChange={this.onChangeRejectCommentSearch}
                      value={this.state.bookRejectComment}
                      rows={5}
                      multiline
                      value={this.state.bookRejectComment}
                      variant="outlined"
                      label="Motivo de rechazo"
                       style={{minWidth:320}}
                />
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({bookingForReject:null})}}>Cancelar</Button>
              </Tooltip>
              <Tooltip title="Rechazar reserva">
                <Button variant="contained" color="primary" onClick={this.onConfirmReject}>Rechazar</Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    bookingList: store.evt.bookingList||[],
    restaurant:store.evt.restaurant||{},
    restaurantList: store.evt.restaurantList,
    profile: store.auth.profile

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetReservations,
      actionSelectRestaurant,
      actionGetRestaurants,
      actionSaveReservationState,
      registerOnChangeReservations
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Reservations)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/restaurants/Reservations.js